// Duplicate of `@/styles/colors.scss`
// for use within components.
//
// Not the best idea to duplicate these values
// (DRY principles and all that), but chances
// of these colours changing are tiny and much
// easier to reason about than defining colours
// in Yaml and processing them into SCSS and
// JS that way!
export default {
	main: '#02234B',
	primary: '#00AEEF',
	success: '#25E064',
	warning: '#F5E842',
	danger: '#E62A39',
	black: '#000000',
	white: '#FFFFFF',
	greyDark: '#A2A2A2',
	greyMedium: '#C8C7CC',
	greyLight: '#EFEFF4',
};
